export default __webpack_public_path__ + "static/media/Transfer line 1.403d67d5.mp3";